import React from "react";
import { useTranslation } from "react-i18next";
import { PayPalCurrencies } from "../../../../constant/paypal.js";
import InputSelect from "../../../form/InputSelect.jsx";
import { toElementProps } from "../../Element.js";
import Button, { ButtonStyles } from "./Button.jsx";

InputSelect; // TODO

const PositionToFlex = {
    left: "--left",
    center: "--center",
    right: "--right",
};

export function BlockHeaderEcommerceButtonsStyles(params = {}) {
    const { MobileBreakpoint } = params;

    return {
        "& .block-header-buttons-wrap": {
            display: "grid",
            alignItems: "center",
            gridGap: "40px",

            "&.--left .block-header-buttons-list": {
                flexDirection: "row",
                // justifyContent: "space-around",
            },

            "&.--center .block-header-buttons-list": {
                justifyContent: "center",
            },

            "&.--right .block-header-buttons-list": {
                flexDirection: "row-reverse",
                // justifyContent: "space-around",
            },

            "& .header-button-wrap": {
                margin: "12px",
            },

            "&.--left .header-button-wrap": {
                marginLeft: "0",
            },

            "&.--right .header-button-wrap": {
                marginRight: "0",
            },

            "&.--left .inputs-container.only-one": {
                gridTemplateColumns: "1fr",

                width: "50%",
                justifySelf: "start",
                marginRight: "auto",

                [MobileBreakpoint]: {
                    gridTemplateColumns: "1fr",
                    width: "100%",
                    justifySelf: "center",
                },
            },
            "&.--right .inputs-container.only-one": {
                width: "50%",
                justifySelf: "flex-end",
                marginLeft: "auto",

                [MobileBreakpoint]: {
                    gridTemplateColumns: "1fr",
                    width: "100%",
                    justifySelf: "center",
                },
            },

            "& .block-header-buttons-list": {
                width: "100%",
                height: "max-content",
                display: "flex",
                flexWrap: "wrap",
                gridGap: "unset",
            },

            "& .product-price-container": {
                display: "grid",
            },

            "& .product-price": {
                display: "grid",
                gridGap: "20px",
                gridAutoFlow: "column",
                justifyContent: "center",
                alignItems: "center",
            },

            "& .product-price-value": {
                fontSize: "40px",
                fontWeight: "bold",
                // color: "#000000",
            },
            "& .product-price-before-discount": {
                fontSize: "26px",
                fontWeight: "normal",
                textDecoration: "line-through",
                // color: "#000000",
            },

            // Select styles fix for Safari
            "& .inputs-container": {
                display: "grid",
                gridAutoFlow: "row",
                gridGap: "20px",
                padding: "40px 0",

                "&.sub": {
                    gridAutoFlow: "column",
                    gridTemplateColumns: "unset",
                    padding: 0,
                },

                "& .product-option-select": {
                    padding: "10px",
                    fontSize: "16px",
                    textAlign: "center",
                    textAlignLast: "center",
                    backgroundColor: "#f0f0f0",
                    color: "#000000",
                    borderRadius: "5px",
                    appearance: "none",
                    "-webkit-appearance": "none",
                    "-moz-appearance": "none",
                    position: "relative",
                    paddingRight: "30px",
                    backgroundImage:
                        "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='16' height='16' fill='black'><path d='M7 10l5 5 5-5H7z'/></svg>\")",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "right",
                },
            },

            "&.--left .inputs-container.sub": {
                justifyContent: "flex-start",
            },
            "&.--right .inputs-container.sub": {
                justifyContent: "flex-end",
            },

            [MobileBreakpoint]: {
                maxHeight: "unset",
                flexDirection: "column",
                paddingBottom: "30px",

                gridTemplateColumns: "1fr !important",
                justifyContent: "center !important",
                "& .inputs-container": {
                    gridTemplateColumns: "1fr !important",
                    justifyContent: "center !important",
                },

                "& .block-header-buttons-list": {
                    display: "flex",
                    flexDirection: "column-reverse !important",
                    gap: " 20px",
                },
            },
        },

        // Select
        /* "& .input-select-wrap": {
            position: "relative",
            display: "block",
            textAlign: "left",
            cursor: "pointer",

            userSelect: "none",

            "& .input-select": {
                display: "inline-block",
                minWidth: "320px",
                padding: "10px 20px",
                border: "1px solid #000000",
                borderRadius: "4px",
                backgroundColor: "#ffffff",
                fontSize: "16px",
                lineHeight: "18.75px",
                resize: "none",

                transition: "all 150ms ease",

                minWidth: "unset",
                paddingRight: "32px",

                // span.input-select {
                //     pointer-events: none;
                // },

                "& .placeholder": {
                    color: "#999999",
                },

                [MobileBreakpoint]: {
                    minWidth: "unset",
                },
            },

            "&.show .input-select-contextmenu": {
                opacity: "1",
                transform: "translateY(0)",
            },

            "&.show .input-select-contextmenu button": {
                pointerEvents: "all",
            },

            "&.show .input-select-icon": {
                transform: "rotateX(180deg)",
            },

            "&.small .input-select": {
                padding: "8px",
                paddingRight: "calc(16px + 5px)",
            },

            "&.no-border .input-select": {
                border: "unset",
            },

            "&.no-padding .input-select": {
                paddingTop: "0",
                paddingLeft: "0",
                paddingBottom: "0",
            },

            "&.small .input-select-icon": {
                right: "8px",
            },
        }, */

        ...ButtonStyles(params),
    };
}

export default function BlockHeaderEcommerceButtons(props) {
    const { t } = useTranslation();
    const { Actions, ProductOptions, Pricing, ProductType, Texts } = props.variables;

    const _ProductOptions = ProductOptions?.filter(option => option?.options?.length > 0);

    const [selectedOptions, setSelectedOptions] = React.useState(
        _ProductOptions?.reduce((acc, option) => {
            acc[option.name] = option.options[0].name;
            return acc;
        }, {})
    );

    const handleSelect = (value, name) => {
        setSelectedOptions(prev => ({ ...prev, [name]: value }));
    };

    // Action Buttons
    let buttonCheckout;

    const actionButtons = (Actions?.slice().reverse() || [])
        ?.map(ab => {
            // Checkout button

            if (ab?.attrs?.name === "CHECKOUT") {
                buttonCheckout = {
                    ...ab,
                    text: Texts?.ButtonPurchase || t("Purchase"),
                    attrs: {
                        ...ab.attrs,
                        "data-name": "CHECKOUT",
                        name: null, // delete button.attrs["name"]
                    },
                };

                return null;
            }

            if (!ab?.text) {
                return null;
            }

            return { ...ab };
        })
        .filter(ab => ab?.attrs?.name !== "CHECKOUT" && !!ab);

    if (!Array.isArray(actionButtons)) {
        console.warn("Action buttons is not array!");
        return null;
    }

    const primaryButton = buttonCheckout ? "CHECKOUT" : `AB-${actionButtons.length - 1}`;

    const position = props.position ?? "center";
    const CNInputsContainer = ["inputs-container", "input-select-wrap"];
    const CNInputs = ["product-option-select", "input-select"];
    const BHCP = props.BlockHeaderContentPosition || props.variables.info?.BlockHeaderContentPosition;

    if (BHCP === "image-text") {
        CNInputs.push("align-right");
    } else if (BHCP === "text-image") {
        CNInputs.push("align-left");
    }

    if (_ProductOptions?.length < 2) {
        CNInputsContainer.push("only-one");
    }

    let price, basis;
    if (!Pricing?.price && !Pricing?.basis) {
        // nothing
    } else if (!Pricing?.basis) {
        price = Pricing.price;
    } else {
        price = Pricing.price;
        basis = Pricing.basis;
    }

    const format = Pricing?.currency && PayPalCurrencies[Pricing.currency]?.format;

    const elProps = toElementProps(props, { className: ["block-header-buttons-wrap", PositionToFlex[position]] });
    return (
        <div {...elProps}>
            <form action="/checkout" method="GET">
                {_ProductOptions?.length > 0 && (
                    <div className={CNInputsContainer.join(" ")}>
                        {(() => {
                            const chunkSize = 2;
                            const chunks = [];

                            for (let i = 0; i < _ProductOptions.length; i += chunkSize) {
                                chunks.push(_ProductOptions.slice(i, i + chunkSize));
                            }

                            if (!Array.isArray(chunks)) {
                                console.warn("chunks is not array!");
                                return null;
                            }

                            return chunks?.map((chunk, index) => {
                                if (!Array.isArray(chunk)) {
                                    console.warn("chunk is not array!");
                                    return null;
                                }

                                return (
                                    <div key={index} className={[...CNInputsContainer, "sub"].join(" ")}>
                                        {chunk?.map((option, index2) => {
                                            if (!Array.isArray(option?.options)) {
                                                console.warn("Options of option is not array!");
                                                return null;
                                            }

                                            return (
                                                <React.Fragment key={`${index}-${index2}`}>
                                                    <select
                                                        className={CNInputs.join(" ")}
                                                        onChange={e => handleSelect(e.target.value, option.name)}
                                                        name={`o[${option.name}]`}
                                                        value={selectedOptions[option.name] || ""}
                                                    >
                                                        {option.options?.map((item, i) => (
                                                            <option key={i} value={item.name}>
                                                                {item.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>
                                );
                            });
                        })()}
                    </div>
                )}

                <div className="block-header-buttons-list">
                    {price &&
                        buttonCheckout &&
                        (() => {
                            const b = buttonCheckout;

                            if (primaryButton === "CHECKOUT") {
                                b.primaryButton = true;
                            }

                            b.className = [...(b.className ?? [])];
                            !b.className.includes("without-gradient") && b.className.push("without-gradient");
                            !b.className.includes("ignore-global") && b.className.push("ignore-global");
                            b.className = b.className.filter((v, i, a) => a.indexOf(v) === i);

                            return (
                                <div className="header-button-wrap">
                                    <Button {...b} type="submit" onClick={() => {}} />
                                </div>
                            );
                        })()}

                    {
                        /* ! TODO */ false &&
                            actionButtons?.map((b, index) => {
                                if (`AB-${index}` === primaryButton) {
                                    b.primaryButton = true;
                                }

                                b.className = [...(b.className ?? [])];
                                !b.className.includes("without-gradient") && b.className.push("without-gradient");
                                !b.className.includes("ignore-global") && b.className.push("ignore-global");
                                b.className = b.className.filter((v, i, a) => a.indexOf(v) === i);

                                return (
                                    <div key={index} className="header-button-wrap">
                                        <Button {...b} for="#" onClick={() => {}} />
                                    </div>
                                );
                            })
                    }

                    <div className="product-price-container">
                        {price && (
                            <div className="product-price">
                                {basis && (
                                    <span className="product-price-before-discount">
                                        {(format || basis).toString().replace(/\%/g, basis)}
                                    </span>
                                )}

                                <span className="product-price-value">
                                    {(format || price).toString().replace(/\%/g, price)}
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </form>
        </div>
    );
}
